import { NextPage } from 'next'
import css from 'styled-jsx/css'
import Catalog from '@ui/components/ministore/Catalog'
import Footer from '@ui/components/shared/Footer'
import Header from '@ui/components/shared/Header'

const IndexPage: NextPage = () => {
  return (
    <div className="product-page">
      <style jsx global>
        {globalStyle}
      </style>

      <>
        <Header haveSaleBar />
        <Catalog />
        <Footer />
      </>
    </div>
  )
}

const globalStyle = css.global`
  .product-page {
    .top-description {
      margin-bottom: 61px;
    }

    @media screen and (max-width: 768px) {
      .product-images {
        margin-bottom: 24px;
      }
    }
  }
`

export default IndexPage
